// @flow
import { keyGivenResourceId } from '../modules/product-note';
import type { ProductNote } from '../modules/product-note';
import * as at from '../actions/action-types';
// types
import type { State as TopLevelState, Action } from '../store';
import type { ReceiveResourceAction } from '../actions';

export const getProductNotes = (
  productNumber: string,
  catalogKey: string,
  state: TopLevelState,
): any => state.productNotes[`${catalogKey}_${productNumber}`];

export type State = {
  [catalogKey_productNumber: string]: {
    isLoading: boolean,
    data: ProductNote[],
  },
};

export const initialState: State = { ...null };

const productNotes = (
  state: State = initialState,
  action: Action,
):
  | State
  | { [string]: { data: Array<ProductNote>, isLoading: boolean, ... } } => {
  switch (action.type) {
    case at.RESOURCE_REQUEST:
      return action.payload.method === 'GET' &&
        action.payload.resourceName === 'PRODUCT_NOTES'
        ? {
            ...state,
            [keyGivenResourceId(action.payload.resourceId || '')]: {
              isLoading: true,
              data: [],
            },
          }
        : state;

    case at.RESOURCE_FAIL_TO_RECEIVE:
      return action.payload.method === 'GET' &&
        action.payload.resourceName === 'PRODUCT_NOTES'
        ? {
            ...state,
            [keyGivenResourceId(action.payload.resourceId || '')]: {
              isLoading: false,
              data: [],
            },
          }
        : state;

    case at.RESOURCE_RECEIVE:
      if (action.payload.resourceName === 'PRODUCT_NOTES') {
        return {
          ...state,
          [keyGivenResourceId(action.payload.resourceId || '')]: {
            isLoading: false,
            data: action.payload.data,
          },
        };
      }
      if (action.payload.resourceName === 'PRODUCT_NOTE') {
        const receiveResourceAction = ((action: any): ReceiveResourceAction);
        const { productNumber, catalogKey } =
          receiveResourceAction.payload.data;
        const key = `${catalogKey}_${productNumber}`;
        switch (receiveResourceAction.payload.method) {
          case 'POST':
          case 'PUT':
            return {
              ...state,
              [key]: {
                ...state[key],
                data: [
                  ...state[key].data.filter(
                    ({ id }) => id !== receiveResourceAction.payload.data.id,
                  ),
                  receiveResourceAction.payload.data,
                ],
              },
            };
          case 'DELETE':
            return {
              ...state,
              [key]: {
                ...state[key],
                data: state[key].data.filter(
                  ({ id }) => id !== receiveResourceAction.payload.data.id,
                ),
              },
            };

          default:
            return state;
        }
      }

      return state;

    case at.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default productNotes;
